
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/items",
      function () {
        return require("private-next-pages/docs/api/items.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/items"])
      });
    }
  